import { PublicMobileNavItemType } from "@/features/layout/types/PublicMobileNavItemType";

export const publicMobileNavigationItems: PublicMobileNavItemType[] = [
  { name: "通告欄", path: "/job" },
  { name: "KOL", path: "/kol" },
  { name: "網誌", path: "/blog" },
];
